//文字コードはutf-8

/* KVイラストの Lottie アニメーション
 *  - ベースの静止画（img_kv.webp）の上に、動く要素だけを描いた Lottie を同じ枠で重ねる
 *  - 静止画は 1973×1464 / Lottie は 1800×1440 で、AE コンポジション内の静止画の
 *    位置・倍率が書き出しとズレているため、両者は同じ枠では重ならない。
 *    CSS 側で Lottie に 1800:1440 の専用枠（静止画枠の97.65%／top -1.44%）を与え、
 *    SVG は preserveAspectRatio:none でその枠いっぱいに描いて座標を一致させる
 *    （実測値の根拠は src/scss/pages/_top.scss の &__lottie のコメント参照）
 *  - 通常時：0〜32＝登場（各要素がポンと現れる）→ 32〜128＝待機ループ（32フレーム周期）
 *    先頭に戻すと登場が繰り返されるため、登場を1回再生してから待機部分だけをループさせる
 *  - JSON が約1.5MBあるため、KV が画面内に入り読み込みが落ち着いてから取得する
 *  Lottie ランタイムは lib/lottie.min.js（グローバル window.lottie）を使用
========================================================*/

// フレーム定義（fr=24 / コンポジション 0–128）
const FRAME = {
    appearIn: 0,   // 登場の開始
    idleIn: 32,    // 待機ループ開始 ＝ 登場の終端
    idleOut: 128,  // 待機ループ終端（値が idleIn と一致するためシームレスに繋がる）
};

// ページの読み込み完了後に実行する（KV画像の表示を JSON 取得で妨げないため）
function afterLoad(callback) {
    if (document.readyState === 'complete') {
        callback();
        return;
    }
    window.addEventListener('load', callback, { once: true });
}

export function initKvLottie() {
    const root = document.querySelector('.jsKvLottie');
    if (!root) return;

    const lottie = window.lottie;
    // ランタイム未読込 or JSONパス未指定なら静止画のみ表示
    if (!lottie || !root.dataset.lottie) return;

    // モーション低減設定時はアニメーションさせず、静止画を維持
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    let anim = null;
    let visible = true;

    const build = () => {
        if (anim) return;
        anim = lottie.loadAnimation({
            container: root,
            renderer: 'svg',
            loop: false,
            autoplay: false,
            path: root.dataset.lottie,
            rendererSettings: {
                // 静止画と同じ枠いっぱいに描いて座標を合わせる
                preserveAspectRatio: 'none',
                progressiveLoad: true,
            },
        });

        // 登場〜待機1周を再生
        anim.playSegments([FRAME.appearIn, FRAME.idleOut], true);
        // 再生が終わったら待機部分だけのループへ切り替える
        anim.addEventListener('complete', () => {
            anim.loop = true;
            anim.playSegments([FRAME.idleIn, FRAME.idleOut], true);
        });

        if (!visible) anim.pause();
    };

    if (!('IntersectionObserver' in window)) {
        afterLoad(build);
        return;
    }

    // 画面外ではアニメーションを停止して負荷軽減
    const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            visible = entry.isIntersecting;
            if (!visible) {
                if (anim) anim.pause(); // 画面外は停止
            } else if (anim) {
                anim.play(); // 再開
            } else {
                afterLoad(build); // 初回はここで読み込む
            }
        });
    }, { threshold: 0 });

    io.observe(root);
}
